import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { ThemeService } from 'src/app/services/theme.service';
import { DesktopVersionComponent } from '../my-task/desktop-version/desktop-version.component';
import { AdvanceSettingsComponent } from '../taskcost/advance-settings/advance-settings.component';
import { UserService } from 'src/app/services/user.service';
import { ConfirmPopupComponent } from '../my-task/confirm-popup/confirm-popup.component';
import { WarningPopupComponent } from '../collections/warning-popup/warning-popup.component';
import { PopupService } from 'src/app/services/popup.service';
import { TaskService } from 'src/app/services/task.service';
import { LeafletUserPreviescreenComponent } from '../leaflet-user-previescreen/leaflet-user-previescreen.component';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {
  currentUser: any = undefined;
  displayedColumns: string[] = ['name', 'displayName', 'department','email', 'preview', 'edit','delete'];
  dataSource = new MatTableDataSource<any>();
  tableDataLength: number;
  userid: any;
  darkTheme: boolean;
  deletedImagePath: string;
  isInIframe: boolean;
  permissions: any[] = [];
  newUser = false;

  constructor(private authService: AuthService,
    private router: Router,
    private localStorageService: DataService,
    private themeService: ThemeService,
    private matdialog: MatDialog,
    private userService: UserService,
    private popupService: PopupService,
    private taskService: TaskService
  ) {
      this.localStorageService.darkTheme.subscribe((newValue) => {
        this.darkTheme = newValue;
        this.deletedImagePath = this.darkTheme
        ? '../../../assets/images/deleted-dark.png'
        : '../../../assets/images/deleted.png';
      });
      this.isInIframe = this.themeService.isInIframe();    
  }

  ngOnInit(): void {
    const castUser = this.authService.castCurrentUser.subscribe(async (res: any) => {
      this.currentUser = await res;

      if (!this.currentUser?.verified) {
        this.authService.logoutAndReset();
      }
      else {
        this.authService.user.subscribe(user => this.currentUser = user);
        this.userid = this.currentUser.id;
        this.loadUserDetails(this.userid);
      }
      castUser.unsubscribe();
    });
  }

  desktopVersion() {
    this.matdialog.open(DesktopVersionComponent, {
      maxWidth: '80%',
      backdropClass: 'blurred',
      disableClose: true,
    });
  }

  getUsers(userId: any,organisationId: any) {
    this.userService.getUser(userId,organisationId).subscribe(
      (result: any) => {
        this.newUser = false;
        this.tableDataLength = result?.users?.length > 0 ? result?.users?.length: 0;

        if (result?.users?.length > 0) {
          this.dataSource = new MatTableDataSource(result?.users);
        }

        if (this.currentUser?.permission_based) {
          this.getPermissions();
        }

        if (this.currentUser?.sub_budget_allocation) {
          this.userService.personalInfo(userId).subscribe({
            next: (res: any) => {
              this.currentUser = res;
            },
            error: (error) => {
            }
    });
        }
      },
      (err) => {
        return false;
      }
    );
  }

  handleButtonClick(event: Event) {
    event.stopPropagation();
  }

  addUser() {
      const dialog = this.matdialog.open(AdvanceSettingsComponent, {
        minWidth: '45%',
        backdropClass: 'blurred',
        disableClose: true,
        data: {type: 'userManagement', user: this.currentUser, permissions: this.permissions},
        autoFocus: false,
      });
  
      dialog.afterClosed().subscribe((result) => {
        this.getUsers(this.userid,this.currentUser.organisationId);
      });
    }


  updateUser(row) {
    const dialog = this.matdialog.open(AdvanceSettingsComponent, {
      minWidth: '45%',
      backdropClass: 'blurred',
      disableClose: true,
      data: {type: 'userManagement', user: this.currentUser, selectedUser: row, permissions: this.permissions}
    });

    dialog.afterClosed().subscribe((result) => {
      this.getUsers(this.userid,this.currentUser.organisationId);
    });
  }

  deleteUser(row) {
    let userObj = {
     userId: this.userid,
     subUserId: row._id,
     action: 'delete'
    }

    const dialogRef = this.matdialog.open(ConfirmPopupComponent, {
      width: '35%',
      disableClose: true,
      backdropClass: 'blurred',
      data: { message: 'userDelete' }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.userService.updateUser(userObj).subscribe((res: any) => {
          if (res) {
            if (res.msg === 'There is an ongoing task for this user') {
              const message = 'There is an ongoing tasking by this user.';
              const type = 'warning'
              this.popupService.openPopup(WarningPopupComponent, message, type, '40%');
            } else this.getUsers(this.userid,this.currentUser.organisationId);      
          }   
         });
      }
    });
  }

  onCheckboxChange(event, row) {
    let userObj = {
      userId: this.userid,
      subUserId: row._id,
      action: event.checked ? 'enable' : 'disable'
    }
    
    this.userService.updateUser(userObj).subscribe((res: any) => {
      if (res) {
        this.getUsers(this.userid, this.currentUser.organisationId);
        if (res.msg === 'There is an ongoing task for this user') {
          const message = 'There is an ongoing tasking by this user.';
          const type = 'warning'
          this.popupService.openPopup(WarningPopupComponent, message, type, '40%');
        }
      }
    });
  }

  loadUserDetails(userId): void {
  if (userId) {
    this.userService.personalInfo(userId).subscribe({
      next: (res: any) => {
        this.currentUser = res;
        if(this.currentUser?.userType != 'Super user') this.router.navigate(['task']);        
        else this.getUsers(this.userid,this.currentUser.organisationId);

        if (this.currentUser?.permission_based) {
          this.newUser = true;
          const columnIndex = this.displayedColumns.indexOf('preview');
          if (columnIndex !== -1) {
            this.displayedColumns.splice(columnIndex + 1, 0, 'permissions');
          }
        }

        if (this.currentUser?.sub_budget_allocation) {
          const columnIndex = this.displayedColumns.indexOf('email');
          if (columnIndex !== -1) {
            this.displayedColumns.splice(columnIndex + 1, 0, 'accountBalance');
          }
        }
      },
      error: (error) => {
      }
    });
  }
}

  getPermissions() {
  this.taskService.getPermissions().subscribe(
      (result: any) => {        
        if (result?.permissions.length > 0) {
          this.permissions = result.permissions;
        }
      },
      (err) => {
        return false;
      }
    );
  }

  listPermissions(row) {
    const matchedPermissions = this.permissions.filter(item => row.permissions.includes(item.level));
    let assignedPermissions = matchedPermissions.map(option => option.permission);
    return assignedPermissions.join('\n');
  }

  OpenPopup(row: any) {
    this.matdialog.open(LeafletUserPreviescreenComponent, {
      width: '50%',
      data: {
        user: row, type: 'permittedArea'
      },
      backdropClass: 'blurred',
      disableClose: true,
    });
  }

}
